module.exports = __webpack_public_path__ + "img/73.d0f5a53f.jpg";